/* Sampunoteka 2026 – small behaviours for custom sections */
(function () {
  var doc = document.documentElement;
  doc.classList.add('smp-js');
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(root) {
    root = root || document;
    /* info bar rotation */
    all('.smp-info__rot', root).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var items = all('span', box); if (items.length < 2) return;
      var i = 0;
      setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4000);
    });
    /* reveal */
    var targets = all('.smp [data-reveal]:not(.is-in)', root);
    if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .12 });
      targets.forEach(function (el) { io.observe(el); });
    } else { targets.forEach(function (el) { el.classList.add('is-in'); }); }
    /* line tabs */
    all('.smp-lines', root).forEach(function (sec) {
      var tabs = all('.smp-tab', sec);
      tabs.forEach(function (t) { t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        all('.smp-panel', sec).forEach(function (p) { p.classList.toggle('is-on', p.id === t.getAttribute('aria-controls')); });
      }); });
    });
    /* carousel */
    all('.smp-best', root).forEach(function (sec) {
      var track = sec.querySelector('.smp-track'), prog = sec.querySelector('.smp-progress i');
      if (!track) return;
      all('.smp-arrow', sec).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth / 2, behavior: 'smooth' }); }); });
      function upd() { if (!prog) return; var max = track.scrollWidth - track.clientWidth, w = Math.min(100, track.clientWidth / track.scrollWidth * 100); prog.style.width = w + '%'; prog.style.left = (max > 0 ? track.scrollLeft / max * (100 - w) : 0) + '%'; }
      track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
